import { render, staticRenderFns } from "./ProductManage.vue?vue&type=template&id=3967096f&scoped=true&"
import script from "./ProductManage.vue?vue&type=script&lang=js&"
export * from "./ProductManage.vue?vue&type=script&lang=js&"
import style0 from "./ProductManage.vue?vue&type=style&index=0&id=3967096f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967096f",
  null
  
)

export default component.exports